<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";

export default {
  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
      data: {},
      tabIndex: 0,
    };
  },
  created() {
    var vm = this;

    vm.syncTabFromRoute();
  },
  mounted() {
    var vm = this;

    vm.load();
  },
  watch: {
    $route() {
      var vm = this;

      vm.load();
    },
    tabIndex(newVal) {
      this.updateTabQuery(newVal);
    }
  },
  methods: {
    syncTabFromRoute() {
      var index = this.$route.query.tabIndex;

      if (index !== undefined) {
        this.tabIndex = Number(index);
      }
    },
    updateTabQuery(index) {
      const current = Number(this.$route.query.tabIndex);

      if (current !== index) {
        this.$router.replace({
          query: {
            ...this.$route.query,
            tabIndex: index
          }
        });
      }
    },
    load() {
      var vm = this;

      vm.create();
      vm.newData();
    },
    newData() {
      var vm = this;

      var data = {
        id: null,
        ref_no: null,
        name: null,
        email: null,
        // phone: null,

        old_password: null,
        password: null,
        password_confirmation: null
      };

      vm.data = Object.assign({}, data);
    },
    async create() {
      var vm = this;

      this.$loading.on('profile_create');
      try {
        vm.newData();

        var resp = await this.$api.Auth.profile();
        var data = resp.data.data;

        vm.data = data;

        this.$loading.off('profile_create');
      } catch (err) {
        this.$flash.error(err.response.data.message);
      }
    },
    async submit() {
      var vm = this;
      this.$loading.on('profile_submit');

      try {
        var postData = vm._createPostData(vm.data);
        var resp = await this.$api.Auth.create(postData);

        var data = resp.data;
        vm.create();

        this.$flash.success(data.message);
      } catch (err) {
        this.$flash.error(err.response.data.message);
      }
      this.$loading.off('profile_submit');
    },
    _createPostData(data) {

      return data;
    },
    async destroy() {
      var vm = this;

      vm.$alert.confirm(vm.$t('basic.alert.delete'), async function (result) {
        if (result.isConfirmed) {
          try {
            vm.$loading.on('profile_delete');

            var resp = await vm.$api.Auth.delete();

            vm.$api.unsetApiToken();
            vm.$router.replace({ name: 'login' });

            vm.$flash.success(resp.data.message);
          } catch (error) {
            vm.$flash.error(error.response.data.message);
          }

          vm.$loading.off('profile_delete');
        }
      });
    },
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="$t('profile.title.detail')" :pageTitle="$t('menu.sub_header.dashboard')" />

    <div class="position-relative mx-n4 mt-n4">
      <div class="profile-wid-bg profile-setting-img">

        <div class="overlay-content">
          <div class="text-end p-3">
            <div class="p-0 ms-auto rounded-circle profile-photo-edit">
            </div>
          </div>
        </div>
      </div>
    </div>

    <BRow>
      <BCol xxl="3">
        <BCard no-body class="mt-n5">
          <BCardBody class="p-3">
            <div class="text-center">
              <!-- <div class="
                  profile-user
                  position-relative
                  d-inline-block
                  mx-auto
                  mb-4
                ">
                <img src="@/assets/images/cafeman/user.svg" class="
                    rounded-circle
                    avatar-xl
                    img-thumbnail
                    user-profile-image
                    shadow
                  " alt="user-profile-image" />
              </div> -->
              <div class="d-flex justify-content-center mb-3 mt-3">
                <div class="avatar-xl">
                  <div
                    class="avatar-title bg-light text-dark rounded-circle d-flex align-items-center justify-content-center">
                    <i class="mdi mdi-account-outline" style="font-size: 75px;"></i>
                  </div>
                </div>
              </div>
              <skeleton :loading="$loading.get('profile_create')" :schema="['col-6', 'col-4', 'col-5']">
                <h5 class="fs-16 mb-1">{{ data.name }}</h5>
                <p class="text-muted mb-0">{{ data.ref_no }}</p>
                <p class="text-muted mb-0">{{ data.email }}</p>
              </skeleton>
            </div>
          </BCardBody>
        </BCard>
      </BCol>
      <BCol xxl="9">
        <BTabs nav-class="profile-nav gap-1 gap-lg-2 text-muted mt-n5" pills lazy v-model="tabIndex">
          <BTab class="nav-item pt-4">
            <template #title>
              <i class="mdi mdi-chart-line d-inline-block d-md-none"></i>
              <span class="d-none d-md-inline-block">{{ $t('profile.tab.detail') }}</span>
            </template>
            <BRow>
              <BCol lg="12">
                <BCard no-body>
                  <b-form @submit="submit">
                    <BCardBody>
                      <loading :loading="$loading.get('profile_create')" variant="dark" type="block">
                        <BRow class="pt-3 mb-3">
                          <BCol lg="12">
                            <div>
                              <label for="name" class="form-label">{{ $t('profile.label.name') }}</label>
                              <input type="text" v-model="data.name" class="form-control" id="name"
                                :placeholder="$t('profile.placeholder.name')"
                                :disabled="$loading.get('profile_create')" />
                            </div>
                          </BCol>
                        </BRow>
                      </loading>
                    </BCardBody>
                    <BCardFooter v-if="($ac.hasAccess('profile_create'))">
                      <div class="hstack gap-2 justify-content-end">
                        <BButton type="submit" variant="success" class="w-sm" :disabled="$loading.get('profile_submit')"
                          v-if="($ac.hasAccess('profile_create'))">
                          <loading :loading="$loading.get('profile_submit')">
                            <i class="mdi mdi-floppy me-1"></i>
                            {{ $t('basic.btn.save') }}
                          </loading>
                        </BButton>
                      </div>
                    </BCardFooter>
                  </b-form>
                </BCard>
              </BCol>
            </BRow>
          </BTab>
          <BTab class="nav-item pt-4">
            <template #title>
              <i class="mdi mdi-chart-line d-inline-block d-md-none"></i>
              <span class="d-none d-md-inline-block">{{ $t('profile.tab.password') }}</span>
            </template>
            <BRow>
              <BCol lg="12">
                <BCard no-body>
                  <b-form @submit="submit">
                    <BCardBody>
                      <loading :loading="$loading.get('profile_create')" variant="dark" type="block">
                        <BRow class="pt-3 mb-3">
                          <BCol lg="12 mb-3">
                            <div>
                              <label for="newpasswordInput" class="form-label">{{ $t('profile.label.old_password')
                              }}</label>
                              <input type="password" v-model="data.old_password" class="form-control"
                                id="oldpasswordInput" :placeholder="$t('profile.placeholder.old_password')"
                                :disabled="$loading.get('profile_create')" />
                            </div>
                          </BCol>
                          <BCol lg="6" class="mb-3">
                            <div>
                              <label for="newpasswordInput" class="form-label">{{ $t('profile.label.password')
                              }}</label>
                              <input type="password" v-model="data.password" class="form-control" id="newpasswordInput"
                                :placeholder="$t('profile.placeholder.password')"
                                :disabled="$loading.get('profile_create')" />
                            </div>
                          </BCol>
                          <BCol lg="6">
                            <div>
                              <label for="confirmpasswordInput" class="form-label">{{
                                $t('profile.label.retype_password')
                              }}</label>
                              <input type="password" v-model="data.password_confirmation" class="form-control"
                                id="confirmpasswordInput" :placeholder="$t('profile.placeholder.retype_password')"
                                :disabled="$loading.get('profile_create')" />
                            </div>
                          </BCol>
                        </BRow>
                      </loading>
                    </BCardBody>
                    <BCardFooter v-if="($ac.hasAccess('profile_create'))">
                      <BRow class="mb-3">
                        <BCol lg="12">
                          <div class="hstack gap-2 justify-content-between">
                            <BButton type="button" variant="danger" class="w-sm d-flex align-items-center"
                              :disabled="$loading.get('profile_delete')" @click="destroy(data.id)"
                              v-if="$ac.hasAccess('profile_delete')">
                              <loading :loading="$loading.get('profile_delete')" variant="light" type="button">
                                <i class="mdi mdi-delete-outline me-1"></i>
                                {{ $t('profile.btn.delete') }}
                              </loading>
                            </BButton>
                            <BButton type="submit" variant="success" class="d-flex align-items-center"
                              :disabled="$loading.get('profile_submit')" v-if="$ac.hasAccess('profile_create')">
                              <loading :loading="$loading.get('profile_submit')" variant="light" type="button">
                                <i class="mdi mdi-floppy me-1"></i>
                                {{ $t('basic.btn.save') }}
                              </loading>
                            </BButton>
                          </div>
                        </BCol>
                      </BRow>
                    </BCardFooter>
                  </b-form>
                </BCard>
              </BCol>
            </BRow>
          </BTab>
        </BTabs>
      </BCol>
    </BRow>
  </Layout>
</template>

<style>
.tamp {
  position: absolute;
  top: 17px;
  right: 16px;
}

.profile-setting-img {
  height: 100px
}
</style>